/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./assetsInfoX.vue?vue&type=template&id=4eb3f8d4"
import script from "./assetsInfoX.vue?vue&type=script&lang=js"
export * from "./assetsInfoX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports